import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import statusChangeService from "./statusService";




export const changeStatus = createAsyncThunk(
  "status/changeStatus",
  async (data: any, thunkAPI) => {
    try {
       const response = await statusChangeService.changeStatus(data);
       console.log('API call successful. Response:', response);
       return response;
    } catch (error: any) {
      console.error('Error in API call:', error);
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const changeMFStatus = createAsyncThunk(
  "status/changeMFStatus",
  async (data: any, thunkAPI) => {
    try {
       const response = await statusChangeService.changeMFStatus(data);
       console.log('API call successful. Response:', response);
       return response;
    } catch (error: any) {
      console.error('Error in API call:', error);
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);


const initialState = {
    data: {},
    totalPages: 0,
    pageIndex: 1,
    isError: false,
    isSuccess: false,
    isLoading: false,
    isDownloading: false, // New state to manage download operation
    message: "",
};

export const changeStatusSlice = createSlice({
    name: "changeStatus",
    initialState,
    reducers: {
      resetState: (state) => initialState,
    },
    
    extraReducers: (builder) => {
      builder
        .addCase(changeStatus.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(changeStatus.fulfilled, (state, action) => {
          state.isLoading = false;
          state.isError = false;
          state.isSuccess = true;
          state.data = action.payload; 
        })
        .addCase(changeStatus.rejected, (state, action) => {
          state.isError = true;
          state.isLoading = false;
          state.isSuccess = false;
          state.message = action.error.message || "";
        })
        .addCase(changeMFStatus.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(changeMFStatus.fulfilled, (state, action) => {
          state.isLoading = false;
          state.isError = false;
          state.isSuccess = true;
          state.data = action.payload; 
        })
        .addCase(changeMFStatus.rejected, (state, action) => {
          state.isError = true;
          state.isLoading = false;
          state.isSuccess = false;
          state.message = action.error.message || "";
        })
    }
    
  
  });
  
  export const { resetState } = changeStatusSlice.actions;
  export default changeStatusSlice.reducer;
